// extracted by mini-css-extract-plugin
export default {"textAreaPageDescriptive":"TextAreaPage_textAreaPageDescriptive__vQA39","textAreaPageNote":"TextAreaPage_textAreaPageNote__+5-aT"};